import { Component, OnInit, Input } from '@angular/core';
import { MainPageService } from '../../main-page.service';
import { DesignBaseModel } from '../../../models/dictionaries/design-base.model';

declare var $: any;


@Component({
  selector: 'app-design-bases-grid',
  template: `<!-- Create Modal -->
<div class="modal" id="addDesignBaseModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div class="display-flex">
                    <span class="modal-label">Name:</span>
                    <input type="text" [(ngModel)]="templateDesignBase.name" #ctrl="ngModel" required>
                </div>
                <div class="display-flex">
                    <span class="modal-label">Description:</span>
                    <input type="text" [(ngModel)]="templateDesignBase.description">
                </div>
                <div class="display-flex">
                    <span class="modal-label">Displacement beam:</span>
                    <input type="number" [(ngModel)]="templateDesignBase.displacementBeam">
                </div>
                <div class="display-flex">
                    <span class="modal-label">Displacement bracket:</span>
                    <input type="number" [(ngModel)]="templateDesignBase.displacementBracket">
                </div>
                <div class="display-flex">
                    <span class="modal-label">Safety factor:</span>
                    <input type="number" [(ngModel)]="templateDesignBase.safetyFactor">
                </div>
                <div class="display-flex">
                    <span class="modal-label">Shear factor:</span>
                    <input type="number" [(ngModel)]="templateDesignBase.shearFactor">
                </div>
                <div class="display-flex">
                    <span class="modal-label">Buckling lenght:</span>
                    <input type="number" [(ngModel)]="templateDesignBase.bucklingLenght">
                </div>
                <div class="display-flex">
                    <span class="modal-label">Min deflection limit:</span>
                    <input type="number" [(ngModel)]="templateDesignBase.minDeflectionLimit">
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="ctrl.invalid" (click)="saveNewDesignBase()">Save</button>
            </div>
        </div>
    </div>
</div>

<!-- Edit Modal -->
<div class="modal" id="editModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div class="display-flex">
                    <span class="modal-label">Name:</span>
                    <input type="text" [(ngModel)]="editedDesignBase.name" #ctrl2="ngModel" required>
                </div>
                <div class="display-flex">
                    <span class="modal-label">Description:</span>
                    <input type="text" [(ngModel)]="editedDesignBase.description">
                </div>
                <div class="display-flex">
                    <span class="modal-label">Displacement beam:</span>
                    <input type="number" [(ngModel)]="editedDesignBase.displacementBeam">
                </div>
                <div class="display-flex">
                    <span class="modal-label">Displacement bracket:</span>
                    <input type="number" [(ngModel)]="editedDesignBase.displacementBracket">
                </div>
                <div class="display-flex">
                    <span class="modal-label">Safety factor:</span>
                    <input type="number" [(ngModel)]="editedDesignBase.safetyFactor">
                </div>
                <div class="display-flex">
                    <span class="modal-label">Shear factor:</span>
                    <input type="number" [(ngModel)]="editedDesignBase.shearFactor">
                </div>
                <div class="display-flex">
                    <span class="modal-label">Buckling lenght:</span>
                    <input type="number" [(ngModel)]="editedDesignBase.bucklingLenght">
                </div>
                <div class="display-flex">
                    <span class="modal-label">Min deflection limit:</span>
                    <input type="number" [(ngModel)]="editedDesignBase.minDeflectionLimit">
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="ctrl2.invalid" (click)="editDesignBase()">Save</button>
            </div>
        </div>
    </div>
</div>

<!-- Delete Modal -->
<div class="modal" id="deleteModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this design base?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="deleteDesignBase(editedDesignBase)">Delete</button>
            </div>
        </div>
    </div>
</div>

<div class="input-effect">
    <input class="effect1" type="text" placeholder="">
    <label>Search</label>
    <span class="focus-border"></span>
</div>
<button class="red-button" type="button" data-toggle="modal" data-target="#addDesignBaseModal">Create</button>

<table>
    <tr>
        <th *ngFor="let header of headers">{{header}}</th>
    </tr>
    <tr *ngFor="let designBase of designBasesGridData, let row_no = index">
        <td>{{designBase.name}}</td>
        <td>{{designBase.description}}</td>
        <td>{{designBase.displacementBeam}}</td>
        <td>{{designBase.displacementBracket}}</td>
        <td>{{designBase.safetyFactor}}</td>
        <td>{{designBase.shearFactor}}</td>
        <td>{{designBase.bucklingLenght}}</td>
        <td>{{designBase.minDeflectionLimit}}</td>
        <td class="columnWithIcons">
            <button type="button" class="btn editBtn" data-toggle="modal" data-target="#editModal" (click)="setChoosenElement(designBase, row_no)">
                <i class="fa fa-edit"></i>
            </button>
            <button type="button" class="btn deleteBtn" data-toggle="modal" data-target="#deleteModal" (click)="setChoosenElement(designBase, row_no)">
                <i class="fa fa-trash"></i>
            </button>
        </td>
    </tr>
</table>

`,
  styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.modal-label{width:168px}.display-flex{display:flex;align-items:center;margin-bottom:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}`]
})
export class DesignBasesGridComponent implements OnInit {
  isComponentHidden = true;
  designBasesGridData: DesignBaseModel[];
  templateDesignBase = new DesignBaseModel();
  editedDesignBase = new DesignBaseModel();
  rowNumber: number;
  headers: string[] = ['Name', 'Description', 'Displacement beam', 'Displacement bracket',
                       'Safety factor', 'Shear factor', 'Buckling lenght', 'Min deflection limit', ''];

  constructor(private mainPageService: MainPageService) {}

  public ngOnInit(): void {
    this.loadGridDataFromDb();
    this.mainPageService.deleteDesignBaseSubject.subscribe( (value) => {
      this.designBasesGridData = this.designBasesGridData.filter(x => x._id !== value);
    });
  }

  loadGridDataFromDb() {
    this.mainPageService.loadAllDesignBases().subscribe((response) => {
      this.designBasesGridData = response.sort(function (a, b) {
        return (a.name < b.name) ? -1 : 1;
      });
    });
  }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
        $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isComponentHidden = !this.isComponentHidden;
  }

  saveNewDesignBase() {
    this.mainPageService.addNewDesignBaseIntoDb(JSON.stringify(this.templateDesignBase)).subscribe((response) => {
      this.templateDesignBase._id = response;
      this.designBasesGridData.push(this.templateDesignBase);
      this.templateDesignBase = new DesignBaseModel();
    });
  }

  setChoosenElement(element, row) {
    this.editedDesignBase = {
      ...element,
    };
    this.rowNumber = row;
  }

  editDesignBase() {
    console.log(this.designBasesGridData[this.rowNumber]);
    Object.assign(this.designBasesGridData[this.rowNumber], this.editedDesignBase);
    this.mainPageService.updateDesignBaseInDb(JSON.stringify(this.editedDesignBase)).subscribe((response) => {});
  }

  deleteDesignBase(element) {
    this.mainPageService.removeDesignBase(element._id).subscribe((res) => {}, (error: any) => {});
    this.mainPageService.deleteDesignBaseSubject.next(element._id);
  }
}
